<template>
  <div class="box">
    <div class="content">
      <div class="card">
        <div class="title">{{ activityData.activityTitle }}</div>
        <div class="time-box">
          <span class="time-title">距离活动结束</span>
          <van-count-down :time="countDownTime">
            <template #default="timeData">
              <div class="countdown-content">
                <span class="block">{{ timeData.days }}</span>
                <span class="space">天</span>
                <span class="block">{{ timeData.hours }}</span>
                <span class="space">时</span>
                <span class="block">{{ timeData.minutes }}</span>
                <span class="space">分</span>
                <span class="block">{{ timeData.seconds }}</span>
                <span class="space">秒</span>
              </div>
            </template>
          </van-count-down>
        </div>
        <div class="money-box">
          <template v-if="activityData.signUpfee > 0">
            <div class="money">
              <div class="symbol-left">
                <span class="rmb">¥</span>
                <span class="title-sign">{{activityData.signUpfeeLabel}}</span>
              </div>
              <span class="number" :style="{fontSize: (activityData.signUpfee.toString().length >= 5 ? '50px' : '')}">{{activityData.signUpfee || 0}}</span>
            </div>
          </template>
          <template v-else>
            <div class="money">
              <span class="number mf">免费</span>
            </div>
          </template>
          <div class="sign-btn">抢</div>
        </div>
        <div class="browse">
          <div class="browse-item">
            <div class="item-left">
              <img class="img-icon" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/E0/rB8LrWU6ET-AatpXAAAFZ-EgVHI344.png" />
              <div class="text">
                已浏览<span>{{signUpData.browsePeopleNumber}}</span>人
              </div>
            </div>
            <img class="item-right" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/DF/rB8LrWU6DVeAMe4PAABMpMuxcVY137.png" />
          </div>
          <div class="browse-item bottom">
            <div class="item-left">
              <img class="img-icon" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/E0/rB8LrWU6EPKAC4syAAAILQZdHcE098.png" />
              <div class="text">
                已参与<span>{{signUpData.signUpNumber}}</span>人
              </div>
            </div>
            <img class="item-right" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/DF/rB8LrWU6DVeAMe4PAABMpMuxcVY137.png" />
          </div>
        </div>
          
        <div class="notice-box" v-if="activityData.boolShowNotice">
          <van-notice-bar left-icon="volume-o" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="3000"
              :show-indicators="false"
            >
              <van-swipe-item v-for="item in signUpData.signUpList" :key="item.userPhone">
                刚刚{{item.joinUserName | joinUserName }}已成功参与活动
              </van-swipe-item>
            </van-swipe>
          </van-notice-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import signUpMixin from './signUpMixin'
export default {
 mixins: [signUpMixin]
}
</script>

<style lang="stylus" scoped>
  .box {
    .content {
      overflow hidden;
      width: 100%;
      // margin-top: -36px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/58/rB8LrWU_DHiAH9pAAADworD4DxI217.png');
      background-size: 100% 100%;
      .card {
        overflow hidden;
        width: 100%;
        min-height: 457px;
        margin-top: 30px;
        background-size: 100% 100%;
        .title {
          width: 287px;
          text-align: center;
          color: #1B9559;
          font-size: 19px;
          font-weight: bold;
          margin: auto;
          margin-top: 60px;
        }
        .time-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          .time-title {
            // width: 100px;
            text-align: center;
            font-size: 15px;
            font-weight: 600;
            color: #6B2F1A;
            margin-top: 15px;
          }
          .countdown-content {
            margin-top: 12px;
            .block {
              display: inline-block;
              width: 39px;
              height: 39px;
              text-align: center;
              line-height: 39px;
              color: #E24409;
              font-size: 20px;
              font-weight: 600;
              border: 1px solid rgba(241,101,19,0.5);
              border-radius: 5px;
              background: rgba(252,230,210,0.2);
            }
            .space {
              font-size: 14px;
              color: #6B2F1A;
              margin: 0 6px;
            }
          }
        }
        .money-box {
          display: flex;
          align-items: center;
          width: 327px;
          height: 100px;
          margin: auto;
          margin-top: 15px;
          background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/57/rB8LrmU_Ds2ADJXbAAEALLOdiDk746.png');
          background-size: 100% 100%;
          overflow hidden
          .money {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            height: 70px;
            margin-left: 14px;
            .symbol-left {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 74px;
              color: #23904F;
              .rmb {
                font-size: 18px;
              }
              .title-sign {
                font-size: 9px;
                writing-mode: tb-rl;
                margin-right: 2px;
              }
            }
            .number {
              line-height: 60px;
              text-align: center;
              color: #23904F;
              font-size: 73px;
              font-weight: bold;
              -webkit-text-stroke: 1px #FFCB75;
              text-stroke: 3px #FFCB75;
              margin-bottom: 4px;
            }
            .mf {
              font-size: 62px;
            }
          }
          .sign-btn {
            width: 50px;
            height: 50px;
            line-height: 50px;
            color: #E44626;
            font-size: 28px;
            font-style: italic;
            text-align: center;
            font-weight: bold;
            margin-bottom: 4px;
            margin-left: 39px;
            border-radius: 4px;
            background: linear-gradient(0deg, #FEDE84 0%, #FFFFFF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
           
          }
        }
        .browse {
          width: 280px;
          margin: auto;
          margin-top: 18px;
          .browse-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item-left {
              display: flex;
              align-items: center;
              .img-icon {
                width: 18px;
                height: 18px;
                margin-right: 10px;
              }
              .text {
                color: #6B2F1A;
                font-size: 14px;
                span {
                  color: #E24409;
                  font-weight: bold;
                  margin: 0 5px;
                }
              }
            }
            .item-right {
              width: 128px;
              height: 22px;
            }
          }
          .bottom {
            margin-top: 21px;
          }
        }
        .notice-box {
          width: 305px;
          height: 24px;
          background: #FFE8AD;
          margin: auto;
          margin-top: 25px;
          >>> .van-notice-bar {
            height: 24px;
            color: #6B2F1A;
            font-size: 12px;
            background: transparent;
          }
          .notice-swipe {
            height: 24px;
            line-height: 24px;
          }
        } 
      }
    }
  }
</style>